import { apiType } from "../../actions/parties/index";

import { combineReducers } from "redux";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function getParties(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case apiType.SEARCH_PARTY_START:
  case apiType.GET_PARTY_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case apiType.SEARCH_PARTY_SUCCESS:
  case apiType.GET_PARTY_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case apiType.SEARCH_PARTY_ERROR:
  case apiType.GET_PARTY_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function createParty(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case apiType.CREATE_PARTY_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case apiType.CREATE_PARTY_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case apiType.CREATE_PARTY_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function editParty(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case apiType.EDIT_PARTY_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case apiType.EDIT_PARTY_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };

  case apiType.EDIT_PARTY_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function deleteParty(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case apiType.DELETE_PARTY_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case apiType.DELETE_PARTY_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };

  case apiType.DELETE_PARTY_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

export const parties = combineReducers({
  getParties,
  createParty,
  editParty,
  deleteParty
});

export default parties;
